import routes from './routes';
import { PtBr, En, Es } from './locales';

const RelatorioRastreabilidadeModule = {
    name: 'relatorio_rastreabilidade',
    routes,
    locales: {
        'pt-BR': PtBr,
        en: En,
        es: Es
    }
};

export default RelatorioRastreabilidadeModule;
